import { render, staticRenderFns } from "./globalConfig.vue?vue&type=template&id=1e142baf&scoped=true"
import script from "./globalConfig.vue?vue&type=script&lang=js"
export * from "./globalConfig.vue?vue&type=script&lang=js"
import style0 from "./globalConfig.vue?vue&type=style&index=0&id=1e142baf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e142baf",
  null
  
)

export default component.exports